import React from 'react'
import { Head, Link, useForm } from '@inertiajs/react'
import { Container, Typography, Box, Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import LocationForm from './Form'

interface GroupOption {
  id: number
  name: string
  company: string
}

interface Props {
  categories: string[]
  groups: GroupOption[]
}

export default function NewLocation({ categories, groups }: Props) {
  const { data, setData, post, processing, errors, transform } = useForm({
    name: '',
    address: '',
    latitude: '',
    longitude: '',
    phone: '',
    category: '',
    description: '',
    website_url: '',
    google_place_id: '',
    group_ids: [] as number[],
  })

  // Inertia's useForm sends a flat body, so wrap it under `location` so Rails
  // strong params (which require :location) receive nested attributes including
  // `group_ids` — `wrap_parameters` only auto-wraps model columns and would
  // strip the has_many :through `group_ids`.
  transform((d) => ({ location: d }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/locations')
  }

  return (
    <>
      <Head title="New Location" />
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Box sx={{ mb: 3 }}>
          <Button
            component={Link}
            href="/locations"
            startIcon={<ArrowBackIcon />}
          >
            Back to Locations
          </Button>
        </Box>

        <Typography variant="h5" sx={{ mb: 4 }}>Add New Location</Typography>

        <LocationForm
          data={data}
          setData={setData}
          categories={categories}
          groups={groups}
          errors={errors as Record<string, string[]>}
          onSubmit={handleSubmit}
          processing={processing}
          submitLabel="Create Location"
        />
      </Container>
    </>
  )
}
